import React from "react";
import { uploadAttachment } from "../../../../../../../api/ApiAttachments";

import { Box } from "@mui/material";

import "./ImagesForm.scss";
import { ImageGalleryRow } from "../../../../../../CustomComponents/ImageGalleryRow/ImageGalleryRow";

export const AttachmentsForm = ({ formValues }) => {
  const handleUpload = (referenced_by_type) => async (selectedFile) => {
    if (!selectedFile) {
      alert("Por favor, selecciona una imagen antes de subirla.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("filename", selectedFile.name);
    formData.append("filepath", `/attachments/${referenced_by_type}`);
    formData.append("filetype", selectedFile.type);
    formData.append("referenced_by_type", referenced_by_type);

    try {
      await uploadAttachment(formValues.uuid, formData);
    } catch (error) {
      console.error("Error subiendo la imagen:", error);
    }
  };

  const sections = [
    "ASBESTOS_INVENTORY",
    "ASBESTOS_SUSCEPTIBILIDAD",
    "EDIFICATION_INVENTORY",
    "LAB_MEASURES",
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "3rem" }}>
      {sections.map((section) => (
        <ImageGalleryRow
          uuid={formValues.uuid}
          handleUpload={handleUpload}
          referenced_by_type={section}
          canDelete
        />
      ))}
    </Box>
  );
};
